import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "image-crop-dialog__inner image-crop-dialog__inner--sheet"
};
const _hoisted_2 = {
  key: 0,
  class: "image-crop-dialog__sheet-head"
};
const _hoisted_3 = {
  class: "image-crop-dialog__title"
};
const _hoisted_4 = ["aria-label", "disabled"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 1,
  class: "image-crop-dialog__board-placeholder",
  "aria-hidden": "true"
};
const _hoisted_7 = {
  key: 1,
  class: "image-crop-dialog__choices"
};
const _hoisted_8 = ["aria-label", "disabled", "onClick"];
const _hoisted_9 = {
  key: 1,
  class: "image-crop-dialog__choice-placeholder",
  "aria-hidden": "true"
};
const _hoisted_10 = {
  class: "image-crop-dialog__hint"
};
const _hoisted_11 = {
  class: "image-crop-dialog__footer image-crop-dialog__footer--sheet"
};
const _hoisted_12 = {
  class: "image-crop-dialog__inner"
};
const _hoisted_13 = {
  class: "image-crop-dialog__header"
};
const _hoisted_14 = {
  class: "image-crop-dialog__title"
};
const _hoisted_15 = {
  class: "image-crop-dialog__header-actions"
};
const _hoisted_16 = ["aria-label", "disabled"];
const _hoisted_17 = ["aria-label"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 1,
  class: "image-crop-dialog__board-placeholder",
  "aria-hidden": "true"
};
const _hoisted_20 = {
  key: 0,
  class: "image-crop-dialog__choices"
};
const _hoisted_21 = ["aria-label", "disabled", "onClick"];
const _hoisted_22 = {
  key: 1,
  class: "image-crop-dialog__choice-placeholder",
  "aria-hidden": "true"
};
const _hoisted_23 = {
  class: "image-crop-dialog__hint"
};
const _hoisted_24 = {
  class: "image-crop-dialog__footer"
};
import { computed, onBeforeUnmount, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { Refresh } from '@element-plus/icons-vue';
import { SurfaceHint } from '@/components/feedback';
import AppImage from '@/components/common/AppImage.vue';
import AppBottomSheet from '@/components/shell/AppBottomSheet.vue';
import { useLayoutBreakpoint } from '@/composables/useLayoutBreakpoint';
import { lockBodyScroll, unlockBodyScroll } from '@/composables/useBodyScrollLock';
import { IMAGE_CROP_MAX_ZOOM, applyCropZoom, clampCropOffset, computeViewportSize, createInitialCropTransform, cropImageToFile, resolveCropPreset } from '@/utils/cover-image-crop';
export default {
  __name: 'ImageCropDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    file: {
      type: File,
      default: null
    },
    preset: {
      type: String,
      default: 'square'
    },
    outputMaxDimension: {
      type: Number,
      default: 400
    },
    showRefresh: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    statusError: {
      type: String,
      default: ''
    },
    choices: {
      type: Array,
      default: () => []
    },
    selectedChoiceId: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'confirm', 'cancel', 'refresh', 'select-choice'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const {
      t
    } = useI18n();
    const {
      isMobile
    } = useLayoutBreakpoint();
    const boardRef = ref(null);
    const objectUrl = ref('');
    const imageWidth = ref(0);
    const imageHeight = ref(0);
    const offsetX = ref(0);
    const offsetY = ref(0);
    const scale = ref(1);
    const minScale = ref(1);
    const boardMax = ref(280);
    const ready = ref(false);
    const confirming = ref(false);
    const errorMessage = ref('');
    const pointers = new Map();
    let dragStart = null;
    let pinchStart = null;
    let closedByConfirm = false;
    let scrollLocked = false;
    function lockCropScroll() {
      if (scrollLocked) return;
      lockBodyScroll();
      scrollLocked = true;
    }
    function unlockCropScroll() {
      if (!scrollLocked) return;
      unlockBodyScroll();
      scrollLocked = false;
    }
    const cropPreset = computed(() => resolveCropPreset(props.preset));
    const presetShape = computed(() => cropPreset.value.shape);
    const viewport = computed(() => computeViewportSize(cropPreset.value.ratio, boardMax.value));
    const boardStyle = computed(() => ({
      width: `${viewport.value.width}px`,
      height: `${viewport.value.height}px`
    }));
    const imageStyle = computed(() => ({
      width: `${imageWidth.value}px`,
      height: `${imageHeight.value}px`,
      transform: `translate(${offsetX.value}px, ${offsetY.value}px) scale(${scale.value})`
    }));
    function measureBoardMax() {
      if (typeof window === 'undefined') return;
      if (isMobile.value) {
        const extra = props.choices.length ? 88 : 0;
        const next = Math.min(window.innerWidth - 32, window.innerHeight - 240 - extra, 360);
        boardMax.value = Math.max(180, Math.round(next));
        return;
      }
      const extra = props.choices.length ? 88 : 0;
      const next = Math.min(280, window.innerWidth - 48, window.innerHeight - 200 - extra);
      boardMax.value = Math.max(160, Math.round(next));
    }
    function revokeObjectUrl() {
      if (objectUrl.value) {
        URL.revokeObjectURL(objectUrl.value);
        objectUrl.value = '';
      }
    }
    function resetTransform() {
      imageWidth.value = 0;
      imageHeight.value = 0;
      offsetX.value = 0;
      offsetY.value = 0;
      scale.value = 1;
      minScale.value = 1;
      ready.value = false;
      confirming.value = false;
      errorMessage.value = '';
      pointers.clear();
      dragStart = null;
      pinchStart = null;
    }
    function applyOffset(nextX, nextY, nextScale) {
      const clamped = clampCropOffset(nextX, nextY, nextScale, imageWidth.value, imageHeight.value, viewport.value.width, viewport.value.height);
      offsetX.value = clamped.x;
      offsetY.value = clamped.y;
      scale.value = nextScale;
    }
    function setZoom(nextScale, originX, originY) {
      const zoomed = applyCropZoom(nextScale, {
        x: offsetX.value,
        y: offsetY.value,
        scale: scale.value
      }, originX, originY, minScale.value, minScale.value * IMAGE_CROP_MAX_ZOOM);
      applyOffset(zoomed.x, zoomed.y, zoomed.scale);
    }
    function initFromImage(nw, nh) {
      imageWidth.value = nw;
      imageHeight.value = nh;
      const initial = createInitialCropTransform(nw, nh, viewport.value.width, viewport.value.height);
      minScale.value = initial.scale;
      applyOffset(initial.x, initial.y, initial.scale);
      ready.value = true;
    }
    function onImageLoad(event) {
      const img = event.target;
      const nw = img.naturalWidth || img.width;
      const nh = img.naturalHeight || img.height;
      if (!nw || !nh) {
        onImageError();
        return;
      }
      initFromImage(nw, nh);
    }
    function onImageError() {
      ready.value = false;
      errorMessage.value = t('imageCrop.loadError');
    }
    function bindFile(file) {
      revokeObjectUrl();
      resetTransform();
      if (!file) return;
      objectUrl.value = URL.createObjectURL(file);
    }
    function onVisibleChange(open) {
      emit('update:modelValue', open);
      if (open) {
        closedByConfirm = false;
        return;
      }
      if (!closedByConfirm) {
        emit('cancel');
      }
    }
    function close(confirmed) {
      emit('update:modelValue', false);
      if (!confirmed) {
        emit('cancel');
      }
    }
    function onClosed() {
      revokeObjectUrl();
      resetTransform();
    }
    function viewportOrigin() {
      return {
        x: viewport.value.width / 2,
        y: viewport.value.height / 2
      };
    }
    function pointerValues() {
      return [...pointers.values()];
    }
    function onPointerDown(event) {
      if (!ready.value) return;
      event.preventDefault();
      boardRef.value?.setPointerCapture?.(event.pointerId);
      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY
      });
      if (pointers.size === 1) {
        dragStart = {
          x: offsetX.value,
          y: offsetY.value,
          px: event.clientX,
          py: event.clientY
        };
        pinchStart = null;
      } else if (pointers.size === 2) {
        const [a, b] = pointerValues();
        pinchStart = {
          dist: Math.hypot(a.x - b.x, a.y - b.y),
          scale: scale.value,
          x: offsetX.value,
          y: offsetY.value
        };
        dragStart = null;
      }
    }
    function onPointerMove(event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY
      });
      if (pointers.size === 2 && pinchStart?.dist) {
        const [a, b] = pointerValues();
        const dist = Math.hypot(a.x - b.x, a.y - b.y);
        const origin = viewportOrigin();
        setZoom(pinchStart.scale * (dist / pinchStart.dist), origin.x, origin.y);
        return;
      }
      if (pointers.size === 1 && dragStart) {
        applyOffset(dragStart.x + (event.clientX - dragStart.px), dragStart.y + (event.clientY - dragStart.py), scale.value);
      }
    }
    function onPointerUp(event) {
      pointers.delete(event.pointerId);
      if (pointers.size < 2) pinchStart = null;
      if (pointers.size === 1) {
        const [left] = pointerValues();
        dragStart = {
          x: offsetX.value,
          y: offsetY.value,
          px: left.x,
          py: left.y
        };
        return;
      }
      dragStart = null;
    }
    function onWheel(event) {
      if (!ready.value) return;
      event.preventDefault();
      const origin = viewportOrigin();
      const factor = event.deltaY < 0 ? 1.08 : 1 / 1.08;
      setZoom(scale.value * factor, origin.x, origin.y);
    }
    async function onConfirm() {
      if (!props.file || !ready.value || confirming.value) return;
      confirming.value = true;
      errorMessage.value = '';
      try {
        const cropped = await cropImageToFile(props.file, {
          x: offsetX.value,
          y: offsetY.value,
          scale: scale.value,
          viewportWidth: viewport.value.width,
          viewportHeight: viewport.value.height
        }, {
          outputMaxDimension: props.outputMaxDimension
        });
        closedByConfirm = true;
        emit('confirm', cropped);
        emit('update:modelValue', false);
      } catch {
        errorMessage.value = t('imageCrop.loadError');
        confirming.value = false;
      }
    }
    watch(() => [props.modelValue, props.file], ([open, file]) => {
      if (open && file) {
        measureBoardMax();
        bindFile(file);
        return;
      }
      if (open && !file) {
        // 预占位阶段：主图区显示 skeleton，等首张到达
        measureBoardMax();
        bindFile(null);
        return;
      }
      if (!open) {
        revokeObjectUrl();
      }
    }, {
      immediate: true
    });
    watch(() => [viewport.value.width, viewport.value.height, imageWidth.value, imageHeight.value], () => {
      if (!imageWidth.value || !imageHeight.value) return;
      initFromImage(imageWidth.value, imageHeight.value);
    });
    watch(boardRef, (el, prev) => {
      prev?.removeEventListener('wheel', onWheel);
      el?.addEventListener('wheel', onWheel, {
        passive: false
      });
    });
    watch(() => props.modelValue, open => {
      if (open) {
        if (!isMobile.value) lockCropScroll();
        measureBoardMax();
        return;
      }
      unlockCropScroll();
    }, {
      immediate: true
    });
    watch(isMobile, mobile => {
      measureBoardMax();
      if (!props.modelValue) return;
      if (mobile) unlockCropScroll();else lockCropScroll();
    });
    watch(() => props.choices.length, () => {
      if (props.modelValue) measureBoardMax();
    });
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', measureBoardMax);
    }
    onBeforeUnmount(() => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', measureBoardMax);
      }
      boardRef.value?.removeEventListener('wheel', onWheel);
      unlockCropScroll();
      revokeObjectUrl();
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _unref(isMobile) ? (_openBlock(), _createBlock(AppBottomSheet, {
        key: 0,
        "model-value": __props.modelValue,
        title: __props.showRefresh ? '' : _ctx.$t('imageCrop.title'),
        "show-header": !__props.showRefresh,
        "show-handle": true,
        "show-close": false,
        "sheet-class": "image-crop-sheet",
        "close-on-click-modal": true,
        "z-index": 4100,
        "onUpdate:modelValue": onVisibleChange,
        onClosed: onClosed
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => close(false))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('imageCrop.cancel')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: confirming.value,
          disabled: !ready.value || __props.refreshing,
          onClick: onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('imageCrop.confirm')), 1)]),
          _: 1
        }, 8, ["loading", "disabled"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.showRefresh ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('imageCrop.title')), 1), _createElementVNode("button", {
          type: "button",
          class: "image-crop-dialog__refresh",
          "aria-label": _ctx.$t('imageCrop.refresh'),
          disabled: __props.refreshing || confirming.value,
          onClick: _cache[0] || (_cache[0] = $event => emit('refresh'))
        }, [_createVNode(_component_el_icon, {
          class: _normalizeClass({
            'is-loading': __props.refreshing
          })
        }, {
          default: _withCtx(() => [_createVNode(_unref(Refresh))]),
          _: 1
        }, 8, ["class"])], 8, _hoisted_4)])) : _createCommentVNode("", true), _createElementVNode("div", {
          ref_key: "boardRef",
          ref: boardRef,
          class: "image-crop-dialog__board",
          style: _normalizeStyle(boardStyle.value),
          onPointerdown: onPointerDown,
          onPointermove: onPointerMove,
          onPointerup: onPointerUp,
          onPointercancel: onPointerUp
        }, [objectUrl.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "image-crop-dialog__image",
          src: objectUrl.value,
          alt: "",
          draggable: "false",
          style: _normalizeStyle(imageStyle.value),
          onLoad: onImageLoad,
          onError: onImageError
        }, null, 44, _hoisted_5)) : (_openBlock(), _createElementBlock("div", _hoisted_6)), _createElementVNode("div", {
          class: _normalizeClass(["image-crop-dialog__frame", `image-crop-dialog__frame--${presetShape.value}`]),
          "aria-hidden": "true"
        }, null, 2)], 36), __props.choices.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.choices, item => {
          return _openBlock(), _createElementBlock("button", {
            key: item.id,
            type: "button",
            class: _normalizeClass(["image-crop-dialog__choice", {
              'is-selected': item.id === __props.selectedChoiceId,
              'is-pending': item.pending || !item.src
            }]),
            "aria-label": _ctx.$t('imageCrop.pickChoice'),
            disabled: __props.refreshing || confirming.value || item.pending || !item.src,
            onClick: $event => emit('select-choice', item.id)
          }, [item.src ? (_openBlock(), _createBlock(AppImage, {
            key: 0,
            src: item.src,
            alt: "",
            eager: "",
            class: "image-crop-dialog__choice-img"
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("span", _hoisted_9))], 10, _hoisted_8);
        }), 128))])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('imageCrop.hintH5')), 1), errorMessage.value || __props.statusError ? (_openBlock(), _createBlock(_unref(SurfaceHint), {
          key: 2,
          message: errorMessage.value || __props.statusError,
          tone: "error"
        }, null, 8, ["message"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["model-value", "title", "show-header"])) : (_openBlock(), _createBlock(_component_el_dialog, {
        key: 1,
        "model-value": __props.modelValue,
        class: "image-crop-dialog",
        width: "min(420px, 92vw)",
        "align-center": "",
        "append-to-body": "",
        "lock-scroll": false,
        "close-on-click-modal": false,
        "show-close": false,
        "destroy-on-close": "",
        "z-index": 4100,
        "onUpdate:modelValue": onVisibleChange,
        onClosed: onClosed
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("header", _hoisted_13, [_createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t('imageCrop.title')), 1), _createElementVNode("div", _hoisted_15, [__props.showRefresh ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "image-crop-dialog__refresh",
          "aria-label": _ctx.$t('imageCrop.refresh'),
          disabled: __props.refreshing || confirming.value,
          onClick: _cache[2] || (_cache[2] = $event => emit('refresh'))
        }, [_createVNode(_component_el_icon, {
          class: _normalizeClass({
            'is-loading': __props.refreshing
          })
        }, {
          default: _withCtx(() => [_createVNode(_unref(Refresh))]),
          _: 1
        }, 8, ["class"])], 8, _hoisted_16)) : _createCommentVNode("", true), _createElementVNode("button", {
          type: "button",
          class: "image-crop-dialog__close",
          "aria-label": _ctx.$t('imageCrop.cancel'),
          onClick: _cache[3] || (_cache[3] = $event => close(false))
        }, " × ", 8, _hoisted_17)])]), _createElementVNode("div", {
          ref_key: "boardRef",
          ref: boardRef,
          class: "image-crop-dialog__board",
          style: _normalizeStyle(boardStyle.value),
          onPointerdown: onPointerDown,
          onPointermove: onPointerMove,
          onPointerup: onPointerUp,
          onPointercancel: onPointerUp
        }, [objectUrl.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "image-crop-dialog__image",
          src: objectUrl.value,
          alt: "",
          draggable: "false",
          style: _normalizeStyle(imageStyle.value),
          onLoad: onImageLoad,
          onError: onImageError
        }, null, 44, _hoisted_18)) : (_openBlock(), _createElementBlock("div", _hoisted_19)), _createElementVNode("div", {
          class: _normalizeClass(["image-crop-dialog__frame", `image-crop-dialog__frame--${presetShape.value}`]),
          "aria-hidden": "true"
        }, null, 2)], 36), __props.choices.length ? (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.choices, item => {
          return _openBlock(), _createElementBlock("button", {
            key: item.id,
            type: "button",
            class: _normalizeClass(["image-crop-dialog__choice", {
              'is-selected': item.id === __props.selectedChoiceId,
              'is-pending': item.pending || !item.src
            }]),
            "aria-label": _ctx.$t('imageCrop.pickChoice'),
            disabled: __props.refreshing || confirming.value || item.pending || !item.src,
            onClick: $event => emit('select-choice', item.id)
          }, [item.src ? (_openBlock(), _createBlock(AppImage, {
            key: 0,
            src: item.src,
            alt: "",
            eager: "",
            class: "image-crop-dialog__choice-img"
          }, null, 8, ["src"])) : (_openBlock(), _createElementBlock("span", _hoisted_22))], 10, _hoisted_21);
        }), 128))])) : _createCommentVNode("", true), _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('imageCrop.hintPc')), 1), errorMessage.value || __props.statusError ? (_openBlock(), _createBlock(_unref(SurfaceHint), {
          key: 1,
          message: errorMessage.value || __props.statusError,
          tone: "error"
        }, null, 8, ["message"])) : _createCommentVNode("", true), _createElementVNode("footer", _hoisted_24, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => close(false))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('imageCrop.cancel')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: confirming.value,
          disabled: !ready.value || __props.refreshing,
          onClick: onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('imageCrop.confirm')), 1)]),
          _: 1
        }, 8, ["loading", "disabled"])])])]),
        _: 1
      }, 8, ["model-value"]));
    };
  }
};